import { ztPublicKeys } from '@xfe/rsa-zt';
export const isProduction = DEPLOY_ENV === 'master';

// noinspection JSUnresolvedVariable
export const ZT_ROOT_ADDRESS = isProduction ? '//pl-api.amazingseasun.com' : '//test-ws.xoyo.com';

export const ZT_PUBLIC_KEY = isProduction ? ztPublicKeys.master : ztPublicKeys.test;

// noinspection JSUnresolvedVariable
export const PASSPORT_ROOT_ADDRESS = isProduction ? '//pf-api.xoyo.com/passport/common_api' : '//my-api-dev.xoyo.com/passport/common_api';

// noinspection JSUnresolvedVariable
export const PASSPORT_USER_ROOT_ADDRESS = isProduction ? '//pf-api.xoyo.com/passport/user_api' : '//my-api-dev.xoyo.com/passport/user_api';

// noinspection JSUnresolvedVariable
export const CAPTCHA_PRE_AUTH = isProduction ? '//pf-api.xoyo.com/passport/common_api/pre_auth' : '//my-api-dev.xoyo.com/passport/common_api/pre_auth';

// noinspection JSUnresolvedVariable
export const IS_MASTER = isProduction;

export const REPORT_CHANNEL = isProduction ? 'prodChannel' : 'testChannel';

/**
 * 是否开启 mock
 * @type {boolean}
 */
export const IS_MOCK_ON = DEPLOY_ENV !== 'master' && window.location.href.indexOf('__MOCK__') > -1;
